import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { date, object, ref, string } from 'yup';

export function useClosedDaysSchema() {
    const { t } = useTranslation();
    return useMemo(
        () =>
            object().shape({
                startDate: date().typeError(t('invalidDate')).required(),
                endDate: date()
                    .nullable()
                    .typeError(t('invalidDate'))
                    .min(ref('startDate'), t('endDateBeforeStartDate')),
                description: string(),
            }),
        [t],
    );
}
